import React, { useEffect } from 'react';
import Image from 'app/Components/Shared/Image/image';
import { isMobile } from 'react-device-detect';
import trackerItemText from './trackerItemText';
import { replaceVariablesInBrackets } from '../../../utilities/StringHelpers/StringHelpers';
import { popUpEnum } from './trackerEnum';
import { insertClickToReport } from './DWHReports';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';
import { abroadInsuranceCreateReportFromTracker } from '../CollaborationInsuranceBlock/abroadInsurancReports';
import { gaReportAbroadInsurance } from '../CollaborationInsuranceBlock/abroadInsuranceGA';
import { abroadInsuranceEnum } from '../CollaborationInsuranceBlock/abroadInsuranceGAEnum';
import './tracker.scss';

const whiteArrow = isMobile ? require('./images/layer8.svg') : require('./images/layer-8-copy-11.svg');
const bell = require('./images/layer-10.svg');
const exclamationMark = require('./images/vector-smart-object_new.svg');
const pinkArrow = require('./images/back-arrow_back-arrow_new.svg');

var text = trackerItemText;

const ArrowCircle = () => {
  return (
    <div className='tracker-more-info'>
      <span>למידע נוסף</span>
      {/* <div className='tracker-arrow-circle-helper'>
        <img src={whiteArrow}></img>
      </div> */}
    </div>
  );
};

const ArrowCircleGeneral = (props) => {
  return (
    <div className='tracker-more-info'>
      <span>{props.text}</span>
    </div>
  );
};

export const AbroadPackageItem = (props) => {
  const abroadPackage = props.abroadPackage;
  const socSysCreationDate = abroadPackage.socSysCreationDate;
  const socEffDate = abroadPackage.socEffactiveDate;
  const socExpDate = abroadPackage.socExpDate;
  const mobile = props.subscriberNumber;
  const title = 'יש לך חבילת חו"ל';

  function renderDates(effDate, expDate) {
    if (expDate == '01/01/2001' || expDate == '01.01.2001' || expDate == null) {
      return `${effDate}`;
    } else {
      return `מ ${effDate} עד ${expDate}`;
    }
  }

  const propsExtended = { ...props, renderDates };

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: propsExtended, popUpType: popUpEnum.ABROAD_PACKAGE })}>
      <div className='tracker-title-and-subtitle'>
        <div className='tracker-title'>
          <div>{title}</div>
        </div>
        <div className='tracker-subtitle'>
          <p>{mobile} | </p>
          <p>{renderDates(socEffDate, socExpDate)}</p>
        </div>
      </div>
      <ArrowCircle />
    </div>
  );
};

export const ManagerCallItem = (props) => {
  let itemText = text.itemList.waitingForCall;

  let date = props.callDate;

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: props._type })}>
      <div className='tracker-pink-border'></div>
      <div className='tracker-title'>
        <div>{itemText.title.value}</div>
      </div>
      <div className='tracker-subtitle'>
        {replaceVariablesInBrackets(itemText.subTitle.value, date)
          .split('\n')
          .map((str, i) => (
            <p key={i}>{str}</p>
          ))}
      </div>
      <ArrowCircle />
    </div>
  );
};

export const TechnicianVisitItem = (props) => {
  let itemText = text.itemList.technicianVisit;
  let type = `${window.Config.brand_Name_HE}`;
  if (props.isInfrastructure) {
    type = 'תשתית';
  }
  if (props.isFiber) {
    type = 'פייבר';
  }

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: props._type })}>
      <div className='tracker-title-and-subtitle'>
        <div className='tracker-title'>
          <div>{replaceVariablesInBrackets(itemText.title.value, type)}</div>
        </div>
        <div className='tracker-subtitle'>
          <p>{itemText.subTitle.value}</p>
          <p style={{ whiteSpace: 'pre' }}>
            {replaceVariablesInBrackets(itemText.dateTime.value, props.visitEndTime, props.visitStartTime, props.visitDate)}
          </p>
        </div>
      </div>
      <ArrowCircle />
    </div>
  );
};


export const AbroadInsuranceItem = (props) => {
  let title = 'יש לך ביטוח נסיעות לחו"ל';
  let dueDate = props.dueDate == null ? '' : props.dueDate.slice(6, 8) + '.' + props.dueDate.slice(4, 6) + '.' + props.dueDate.slice(0, 4);
  useEffect(() => {
    abroadInsuranceCreateReportFromTracker('Ongoing', 'Insurance Message Displayed', dueDate, props.name, props.ban, props.subscriber, props.id);
    gaReportAbroadInsurance(abroadInsuranceEnum.ApprovedInsuranceMessage);
  }, []);


  return (
    <div className='tracker-item' onClick={() => {
      props.setCurrentSubscriber(props.subscriber), prepareUrl(props.abroadInsuranceUrl, props.context),
        abroadInsuranceCreateReportFromTracker(
          'Completed', 'Insurance Message Clicked', dueDate, props.name, props.ban, props.subscriber, props.id),
        gaReportAbroadInsurance(abroadInsuranceEnum.InfoButtonLobby);
    }}>
      <div className='tracker-title-and-subtitle'>
        <div className='tracker-title'>
          <div>{title}</div>
        </div>
        <div className='tracker-subtitle'>
          <p>
            <span>למנוי</span>
            <span>&nbsp;</span>
            <span style={{ fontWeight: "bold" }}>{props.subscriber}</span>
            <span>&nbsp;</span>
            <span>קיים ביטוח נסיעה לחו"ל עד</span>
            <span>&nbsp;</span>
            <span style={{ fontWeight: "bold" }}>{dueDate}</span>
          </p>
          <p style={{ whiteSpace: 'pre' }}>
            {''}
          </p>
        </div>
      </div>
      <ArrowCircleGeneral text={'למידע ועדכון הפוליסה'} />
    </div>
  );
};

export const RefundItem = (props) => {
  let itemText = text.itemList.refund[props.refundStatus];
  let date = props.dueDate;

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: popUpEnum.REFUND })}>
      <div className='tracker-title-and-subtitle'>
        <div className='tracker-title'>
          <div>{itemText.title.value}</div>
        </div>
        <div className='tracker-subtitle'>
          {itemText.subTitle !== '' && date != null
            ? replaceVariablesInBrackets(itemText.subTitle.value, date)
              .split('\n')
              .map((str, i) => <p key={i}>{str}</p>)
            : ''}
        </div>
      </div>
      <ArrowCircle />
    </div>
  );
};

export const FollowUpRefundItem = (props) => {
  let itemText = text.itemList.followUpRefund[props.refundStatus];

  let date = props.dueDate;

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: popUpEnum.FOLLOWUPREFUND })}>
      <div className='tracker-title-and-subtitle'>
        <div className='tracker-title'>
          <div>{itemText.title.value}</div>
        </div>
        <div className='tracker-subtitle'>
          {itemText.subTitle !== undefined
            ? replaceVariablesInBrackets(itemText.subTitle.value, date)
              .split('\n')
              .map((str, i) => <p key={i}>{str}</p>)
            : ''}
        </div>
      </div>
      <ArrowCircle />
    </div>
  );
};

export const PlanChangeItem = (props) => {
  let itemText = text.itemList.changePricePlan[props.planChangeType];

  let date = props.dueDate === undefined ? '' : props.dueDate;
  let phone = props.cellularNo === undefined ? '' : props.cellularNo;

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: popUpEnum.PLANCHANGE })}>
      <div className='tracker-title-and-subtitle'>
        <div className='tracker-title'>
          <div>{itemText.title.value}</div>
        </div>
        <div className='tracker-subtitle'>
          {replaceVariablesInBrackets(itemText.subTitle.value, date, phone)
            .split('\n')
            .map((str, i) => (
              <p key={i}>{str}</p>
            ))}
        </div>
      </div>
      <ArrowCircle />
    </div>
  );
};

export const CustomerDeliveriesItem = (props) => {
  const title = 'מתואמת לכם שליחות';

  return (
    <div className='tracker-item' onClick={() => props.onItemClick({ popUpProps: props, popUpType: popUpEnum.CUSTOMER_DEVLIVERIES })}>
      <div className='tracker-title-and-subtitle'>
        <div className='tracker-title'>
          <div>{title} </div>
        </div>
        <div className='tracker-subtitle'>
          <p>{props?.status}: </p>
          <p>
            {props?.deliverySlots[0]?.date} | {props?.deliverySlots[0]?.start}-{props?.deliverySlots[0]?.end}
          </p>
        </div>
      </div>
      <ArrowCircle />
    </div>
  );
};

export const FinanceIssueItem = (props) => {
  const ArrowCircle = (props) => {
    return (
      <div className={`tracker-more-info tracker-more-info-finance-issue tracker-more-info-${props.issueType.toLowerCase()}`}>
        <span
          onClick={
            props.issueType === 'DebtIssue'
              ? () => navigateToDebtIssuePage(props.issueType)
              : () => navigateToPaymentMethodPage(props.issueType)
          }>
          {props.text}
        </span>
      </div>
    );
  };
  const title = 'לתשומת ליבך,';
  const financeIssueType = props.banFinanceIssueType;
  let displayIssueText = '';
  let referenceLinks = null;

  const ShowLinks = (issueType) => {
    if (issueType == 'NoPaymentMethodAndDebtIssue') {
      return (
        <div className='d-flex'>
          <ArrowCircle text={'עדכון אמצעי תשלום'} issueType={'NoPaymentMethod'} />
          <ArrowCircle text={'תשלום החוב'} issueType={'DebtIssue'} />
        </div>
      );
    }
    if (issueType == 'DebtIssue') {
      return <ArrowCircle text={'תשלום החוב'} issueType={issueType} />;
    }
    if (issueType == 'NoPaymentMethod') {
      return <ArrowCircle text={'עדכון אמצעי תשלום'} issueType={issueType} />;
    }
  };

  const navigateToPaymentMethodPage = (issueTypeClicked) => {
    let linkTypeClicked = issueTypeClicked.substring(0, 15);
    insertClickToReport(linkTypeClicked);
    props.context.navigateTo(props.URLs.paymentMethodIssue.value.url);
  };

  const navigateToDebtIssuePage = (issueTypeClicked) => {
    let linkTypeClicked = issueTypeClicked.substring(18);
    insertClickToReport(linkTypeClicked);
    props.context.navigateTo(props.URLs.debtIssue.value.url);
  };




  if (financeIssueType === 'NoPaymentMethodAndDebtIssue') {
    displayIssueText = props.URLs.debtIssueAndUpdatePaymentMethodText.value;
    referenceLinks = ShowLinks(financeIssueType);
  } else if (financeIssueType === 'NoPaymentMethod') {
    displayIssueText = props.URLs.updatePaymentMethodText.value;
    referenceLinks = ShowLinks(financeIssueType);
  } else {
    displayIssueText = props.URLs.debtIssueText.value;
    referenceLinks = ShowLinks(financeIssueType);
  }
  return (
    <div className='tracker-item item-finance-issue' style={{ cursor: 'unset', border: 'solid 1px var(--theme-primary, #9631ff);' }}>
      {/* <div className='tracker-img-item d-flex flex-wrap align-items-center'>
        <img src={exclamationMark}></img>
      </div> */}
      <div className='tracker-title-and-subtitle'>
        <div className='tracker-title'>
          <div>
            {title} {props.URLs.firstLineText.value}
          </div>
        </div>
        <div className='tracker-subtitle'>
          <p>{displayIssueText}</p>
          {/* <div className='vls'></div> */}
        </div>
      </div>
      {referenceLinks}
    </div>
  );
};

export const TrackerShowMore = (props) => {
  if (props.isFinanceIssue && props.totalItems == 1) {
    return '';
  }

  let showMoreMsg = 'עוד (' + props.num + ') הודעות';

  let backComp = (
    <span style={{ opacity: props.showBack ? '1' : '0' }} className='tracker-show-more-back'>
      <Image src={whiteArrow}/>חזרה
    </span>
  );

  let noMoreMsgEnd = <span className='tracker-show-more-end'>זהו, אין עוד</span>;

  let moreMsg = (
    <span className='tracker-show-more-next'>
      {showMoreMsg}
      <Image src={whiteArrow}/>
    </span>
  );

  let showMoreComp = (
    <div
      className='tracker-show-more'
      onClick={
        !props.isShowTracker
          ? () => {
            props.setIsShowTracker(true);
          }
          : null
      }>
      {backComp}
      {props.num === 0 ? noMoreMsgEnd : moreMsg}
    </div>
  );
  return showMoreComp;
};

export const TrackerBaseMessage = (props) => {
  let basicMessage = `יש לך עדכון אחד`;
  if (props.totalItems > 1) {
    basicMessage = `יש לך ${props.totalItems} עדכונים`;
  }

  return (
    <div className='tracker-basic-message' style={props.whiteTitle ? { color: 'white' } : {}}>
      {basicMessage}
    </div>
  );
};
